import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import { Provider } from 'react-redux';
import { useWillMount } from '@beef/react';
import { emptyObj, passAsIs, passUndefined } from '@beef/utils';
import { populateStore } from "./index";

/**
 * HOC for connecting App redux store
 * WrappedComponent is not supposed to remount and will erase shop data on each new mount
 * */
export default function withReduxStore(initializeStore) {
  var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : emptyObj,
    _ref$mapPropsToState = _ref.mapPropsToState,
    mapPropsToState = _ref$mapPropsToState === void 0 ? passAsIs : _ref$mapPropsToState,
    _ref$passThroughProps = _ref.passThroughProps,
    passThroughProps = _ref$passThroughProps === void 0 ? passUndefined : _ref$passThroughProps;
  return function (WrappedComponent) {
    return function (props) {
      var store = initializeStore();

      /**
       * It's important to populate store before render
       */
      useWillMount(function () {
        store.dispatch(populateStore(mapPropsToState(props)));
      });
      return /*#__PURE__*/React.createElement(Provider, {
        store: store,
        "data-t-id": "src-store"
      }, /*#__PURE__*/React.createElement(WrappedComponent, _extends({}, passThroughProps(props), {
        "data-t-id": "src-store"
      })));
    };
  };
}